var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("版本号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("版本号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.versionNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "versionNumber", $$v);
      },
      expression: "form.versionNumber"
    }
  })], 1), _c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("申请时间")
    }
  }, [_c("a-date-picker", {
    attrs: {
      format: _vm.getFormatDate()
    },
    on: {
      change: function ($event) {
        _vm.form.createAt = _vm.form.createAt ? _vm.form.createAt : "";
      }
    },
    model: {
      value: _vm.form.createAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "createAt", $$v);
      },
      expression: "form.createAt"
    }
  })], 1), _c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("审核结果")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("类型"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, _vm._l(_vm.statusList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("发布应用")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("发布应用"),
      allowClear: "",
      "filter-option": _vm.filterOption,
      "show-search": "",
      "option-filter-prop": "children"
    },
    model: {
      value: _vm.form.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applicationId", $$v);
      },
      expression: "form.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(" " + _vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ")-" + _vm._s(item.customerName) + " ")]);
  }), 1)], 1), _c("a-form-item", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _vm.isAuth("home.applicationVersionStore") ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("发起申请")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "customText",
      fn: function (text, record) {
        return [_c("span", [_vm._v(_vm._s(_vm.$t(text)))])];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("home.applicationVersionDetail") ? _c("a-button", {
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleSee(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.addVersionShow ? _c("add-version-model", {
    ref: "addVersionFrom",
    on: {
      cancel: function ($event) {
        _vm.addVersionShow = false;
      },
      ok: _vm.searchFun
    }
  }) : _vm._e(), _vm.seeVersionShow ? _c("see-version-model", {
    ref: "seeVersionFrom",
    on: {
      cancel: function ($event) {
        _vm.seeVersionShow = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };